<script>
import { mapGetters } from 'vuex'
export default
{
    name: 'mv-sidebar',

    computed:
    {
        ...mapGetters({
            user: 'authUser',
            locale: 'generalCurrentLocale',
        })
    },

    methods:
    {
        logout()
        {
            this.$store.dispatch('authLogout').then(() => {
                this.$router.replace('/login')
            })
        },

        goToProfile()
        {
            this.$router.push('/profile')
        },

        changeLang(locale)
        {
            this.$store.dispatch('localeSet', locale)
        },
    },

    data()
    {
        return {
            title: process.env.TITLE,
        }
    },
}
</script>

<template>
    <nav class="navbar navbar-default navbar-side navbar-fixed-top" role="navigation">

        <div id="container">

            <div class="navbar-header">
                <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar" aria-controls="navbar">
                    <span class="sr-only">{{ $t('GENERAL.TOGGGLE_NAVIGATION') }}</span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
                <router-link to="/" class="navbar-brand">{{ title }}</router-link>
            </div>

            <aside class="collapse navbar-collapse" id="navbar">
                <mv-menu>
                    <div class="profile">
                        <div class="user-image-big">
                            <mv-user-image :user="user"></mv-user-image>
                        </div>
                        <div class="user-image-small">
                            <mv-user-image :user="user" :size="32"></mv-user-image>
                        </div>
                        <div class="user-name">{{ user.name }}</div>
                        <button class="btn btn-warning" @click.prevent.stop="changeLang('en')" v-if="locale == 'hu'">EN</button>
                        <button class="btn btn-warning" @click.prevent.stop="changeLang('hu')" v-if="locale == 'en'">HU</button>
                        <button class="btn btn-success btn-icon" @click.prevent.stop="goToProfile"><icon name="user"></icon></button>
                        <button class="btn btn-success btn-icon" @click.prevent.stop="logout"><icon name="sign-out"></icon></button>
                    </div>
                </mv-menu>
            </aside>

        </div>

    </nav>
</template>

<style lang="scss">

.navbar {
    .profile {
        .user-name {
            margin: 1em 0;
        }

        @media (min-width:768px) {
            .user-image-big img {
                display: none;
            }

            .user-image-small img {
                display: inline-block;
                margin-bottom: 1em;
            }

            .user-name {
                display: none;
            }
        }

        @media (min-width:1200px) {
            .user-image-big img {
                display: inline-block;
            }

            .user-image-small img {
                display: none;
            }

            .user-name {
                display: block;
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/sidebar/Sidebar.vue